import React, { useState } from "react";
import logo from "../../../Assets/icon.png";
import "./Login.css";
import { DynamicFormLabel } from "../../Reusables";
import * as validator from "../../../Utilities/Validators";
import * as _ from "lodash";
import { Button, Form, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { setCurrentUser } from "../../../store/slices/userSlice";
import { apiClient } from "../../../Utilities/apiClient";
import { setTokens, loginSuccess } from "../../../store/slices/authSlice";

interface Errors {
  email?: string;
  password?: string;
}

const Login: React.FC = () => {
  const lang = "en";
  const dispatch = useDispatch();


  const [show, setShow] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [errors, setErrors] = useState<Errors>({});

  const hasError = (field: keyof Errors): string | undefined => {
    return errors[field];
  };

  const submit = async () => {
    setShow(true);
    let errorsObj: Errors = {};
    if (validator.validateEmail(email).status === 0) {
      errorsObj.email = validator.validateEmail(email).error;
    }
    if (validator.validateLogInPassword(password).status === 0) {
      errorsObj.password = validator.validateLogInPassword(password).error;
    }
    if (!_.isEmpty(errorsObj)) {
      setErrors(errorsObj);
      setShow(false);
      return;
    }

    const requestBody = {
      identifier: email.toLowerCase(),
      password,
    };
    
    try {
      const response = await apiClient.post('/auth/login', requestBody);
      
      dispatch(setCurrentUser(response.data.user));
      dispatch(setTokens(response.data.tokens));
      dispatch(loginSuccess());
      setShow(false);
    } catch (error: any) {
      setShow(false);
      
      if (error.response?.status === 400 || error.response?.status === 401) {
        setErrors({ 
          email: "Invalid email or password. Please check your credentials and try again."
        });
      } else {
        setErrors({
          email: "Login failed. Please try again later."
        });
      }
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <div className="login-header">
          <img src={logo} width={120} alt="Darb Logo" className="login-logo" />
          <h2 className="login-title">Darb Admin Panel</h2>
          <p className="login-subtitle">Please sign in to continue</p>
        </div>
        
        <Form className="admin-login-form">
          <Form.Group className="mb-3" controlId="formEmail">
            <Form.Label className="form-label">Email Address</Form.Label>
            <Form.Control
              type="email"
              placeholder="admin@darb-mea.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={`form-control ${hasError("email") ? "is-invalid" : ""}`}
              size="lg"
            />
            {hasError("email") && (
              <div className="invalid-feedback">
                {errors.email}
              </div>
            )}
          </Form.Group>

          <Form.Group className="mb-4" controlId="formPassword">
            <Form.Label className="form-label">Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={`form-control ${hasError("password") ? "is-invalid" : ""}`}
              size="lg"
            />
            {hasError("password") && (
              <div className="invalid-feedback">
                {errors.password}
              </div>
            )}
          </Form.Group>
          
          <Button 
            variant="primary" 
            onClick={submit} 
            className="admin-login-btn w-100"
            size="lg"
            disabled={show}
          >
            {show ? (
              <>
                <div className="spinner-border spinner-border-sm me-2" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                Signing In...
              </>
            ) : (
              <>
                <i className="fas fa-sign-in-alt me-2"></i>
                Sign In
              </>
            )}
          </Button>
        </Form>
      </div>
      
      <Modal show={show} backdrop="static" keyboard={false} centered>
        <Modal.Body className="text-center py-4">
          <div className="spinner-border text-primary mb-3" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mb-0">Validating your credentials...</p>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Login;
